import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "row g-3 mb-5" }
const _hoisted_3 = { class: "filter-section mb-4" }
const _hoisted_4 = { class: "desktop-timeline-view" }
const _hoisted_5 = {
  key: 0,
  class: "day-section mb-4"
}
const _hoisted_6 = { class: "timeline" }
const _hoisted_7 = { class: "location-columns-container" }
const _hoisted_8 = { class: "events-container" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "accordion-item" }
const _hoisted_11 = ["id"]
const _hoisted_12 = ["onClick", "aria-expanded", "aria-controls"]
const _hoisted_13 = ["id", "aria-labelledby"]
const _hoisted_14 = { class: "accordion-body" }
const _hoisted_15 = { class: "timeline" }
const _hoisted_16 = {
  key: 1,
  class: "day-section mb-4"
}
const _hoisted_17 = { class: "timeline" }
const _hoisted_18 = { class: "location-columns-container" }
const _hoisted_19 = { class: "events-container" }
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "accordion-item" }
const _hoisted_22 = ["id"]
const _hoisted_23 = ["onClick", "aria-expanded", "aria-controls"]
const _hoisted_24 = ["id", "aria-labelledby"]
const _hoisted_25 = { class: "accordion-body" }
const _hoisted_26 = { class: "timeline" }
const _hoisted_27 = { class: "tablet-list-view" }
const _hoisted_28 = {
  key: 0,
  class: "day-section mb-4"
}
const _hoisted_29 = { class: "row g-3" }
const _hoisted_30 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_31 = {
  key: 1,
  class: "day-section mb-4"
}
const _hoisted_32 = { class: "row g-3" }
const _hoisted_33 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_34 = { class: "mobile-list-view" }
const _hoisted_35 = {
  key: 0,
  class: "day-section mb-4"
}
const _hoisted_36 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_37 = {
  key: 1,
  class: "day-section mb-4"
}
const _hoisted_38 = {
  key: 0,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Agenda = _resolveComponent("Agenda")!
  const _component_AgendaEntry = _resolveComponent("AgendaEntry")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "pb-1" }, "Programm", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Agenda, {
          agendatype: "filter",
          "show-filter": true,
          "show-dates": true,
          "search-text": _ctx.searchtext,
          "active-filters": _ctx.activeFilters,
          "onUpdate:searchText": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchtext = $event)),
          "onUpdate:activeFilters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeFilters = $event)),
          class: "filter-agenda"
        }, null, 8, ["search-text", "active-filters"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showDay1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "font-weight-bold pb-3" }, "MONDAY, JULY 7, 2025", -1)),
              _createElementVNode("div", {
                class: "location-header-grid",
                style: _normalizeStyle(_ctx.gridStyle)
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "time-header-spacer" }, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeLocations, (location) => {
                  return (_openBlock(), _createElementBlock("h5", {
                    key: `h-d1-${location}`
                  }, _toDisplayString(location), 1))
                }), 128)),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "time-header-spacer" }, null, -1))
              ], 4),
              _createElementVNode("div", {
                class: "timeline-grid",
                style: _normalizeStyle(_ctx.gridStyle)
              }, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (time) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `d1-tl-${time}`,
                      class: "time-slot"
                    }, _toDisplayString(_ctx.formatTimeAmPm(time)), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeLocations, (location) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "location-column",
                      key: `d1-${location}`
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedFilteredEventsDay1[location], (events, timeKey) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: `d1-${location}-${timeKey}`
                          }, [
                            (events.length === 1)
                              ? (_openBlock(), _createBlock(_component_AgendaEntry, {
                                  key: 0,
                                  ae: events[0],
                                  agendatype: "timeline",
                                  style: _normalizeStyle(_ctx.getEventStyle(events[0]))
                                }, null, 8, ["ae", "style"]))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "accordion timeline-accordion",
                                  style: _normalizeStyle(_ctx.getAccordionStyle(events, `accordion-d1-${location}-${String(timeKey).replace(':', '')}` === _ctx.currentlyOpenAccordionId)),
                                  id: `accordion-d1-${location}-${String(timeKey).replace(':', '')}`
                                }, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("h2", {
                                      class: "accordion-header",
                                      id: `heading-d1-${location}-${String(timeKey).replace(':', '')}`
                                    }, [
                                      _createElementVNode("button", {
                                        class: _normalizeClass(["accordion-button", { 'collapsed': _ctx.currentlyOpenAccordionId !== `accordion-d1-${location}-${String(timeKey).replace(':', '')}` }]),
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.toggleAccordion(`accordion-d1-${location}-${String(timeKey).replace(':', '')}`)),
                                        "aria-expanded": _ctx.currentlyOpenAccordionId === `accordion-d1-${location}-${String(timeKey).replace(':', '')}`,
                                        "aria-controls": `collapse-d1-${location}-${String(timeKey).replace(':', '')}`
                                      }, _toDisplayString(events.length) + " Sessions at " + _toDisplayString(_ctx.formatTimeAmPm(String(timeKey))), 11, _hoisted_12)
                                    ], 8, _hoisted_11),
                                    _createElementVNode("div", {
                                      id: `collapse-d1-${location}-${String(timeKey).replace(':', '')}`,
                                      class: _normalizeClass(["accordion-collapse collapse", { 'show': _ctx.currentlyOpenAccordionId === `accordion-d1-${location}-${String(timeKey).replace(':', '')}` }]),
                                      "aria-labelledby": `heading-d1-${location}-${String(timeKey).replace(':', '')}`
                                    }, [
                                      _createElementVNode("div", _hoisted_14, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events, (ae) => {
                                          return (_openBlock(), _createBlock(_component_AgendaEntry, {
                                            key: `d1-${location}-${timeKey}-${ae.objvalueid}`,
                                            ae: ae,
                                            agendatype: "accordion-timeline"
                                          }, null, 8, ["ae"]))
                                        }), 128))
                                      ])
                                    ], 10, _hoisted_13)
                                  ])
                                ], 12, _hoisted_9))
                          ], 64))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (time) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `d1-tr-${time}`,
                      class: "time-slot"
                    }, _toDisplayString(_ctx.formatTimeAmPm(time)), 1))
                  }), 128))
                ])
              ], 4)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDay2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "font-weight-bold pb-3" }, "TUESDAY, JULY 8, 2025", -1)),
              _createElementVNode("div", {
                class: "location-header-grid",
                style: _normalizeStyle(_ctx.gridStyle)
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "time-header-spacer" }, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeLocations, (location) => {
                  return (_openBlock(), _createElementBlock("h5", {
                    key: `h-d2-${location}`
                  }, _toDisplayString(location), 1))
                }), 128)),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "time-header-spacer" }, null, -1))
              ], 4),
              _createElementVNode("div", {
                class: "timeline-grid",
                style: _normalizeStyle(_ctx.gridStyle)
              }, [
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (time) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `d2-tl-${time}`,
                      class: "time-slot"
                    }, _toDisplayString(_ctx.formatTimeAmPm(time)), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeLocations, (location) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "location-column",
                      key: `d2-${location}`
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedFilteredEventsDay2[location], (events, timeKey) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: `d2-${location}-${timeKey}`
                          }, [
                            (events.length === 1)
                              ? (_openBlock(), _createBlock(_component_AgendaEntry, {
                                  key: 0,
                                  ae: events[0],
                                  agendatype: "timeline",
                                  style: _normalizeStyle(_ctx.getEventStyle(events[0]))
                                }, null, 8, ["ae", "style"]))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "accordion timeline-accordion",
                                  style: _normalizeStyle(_ctx.getAccordionStyle(events, `accordion-d2-${location}-${String(timeKey).replace(':', '')}` === _ctx.currentlyOpenAccordionId)),
                                  id: `accordion-d2-${location}-${String(timeKey).replace(':', '')}`
                                }, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("h2", {
                                      class: "accordion-header",
                                      id: `heading-d2-${location}-${String(timeKey).replace(':', '')}`
                                    }, [
                                      _createElementVNode("button", {
                                        class: _normalizeClass(["accordion-button", { 'collapsed': _ctx.currentlyOpenAccordionId !== `accordion-d2-${location}-${String(timeKey).replace(':', '')}` }]),
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.toggleAccordion(`accordion-d2-${location}-${String(timeKey).replace(':', '')}`)),
                                        "aria-expanded": _ctx.currentlyOpenAccordionId === `accordion-d2-${location}-${String(timeKey).replace(':', '')}`,
                                        "aria-controls": `collapse-d2-${location}-${String(timeKey).replace(':', '')}`
                                      }, _toDisplayString(events.length) + " Sessions at " + _toDisplayString(_ctx.formatTimeAmPm(String(timeKey))), 11, _hoisted_23)
                                    ], 8, _hoisted_22),
                                    _createElementVNode("div", {
                                      id: `collapse-d2-${location}-${String(timeKey).replace(':', '')}`,
                                      class: _normalizeClass(["accordion-collapse collapse", { 'show': _ctx.currentlyOpenAccordionId === `accordion-d2-${location}-${String(timeKey).replace(':', '')}` }]),
                                      "aria-labelledby": `heading-d2-${location}-${String(timeKey).replace(':', '')}`
                                    }, [
                                      _createElementVNode("div", _hoisted_25, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events, (ae) => {
                                          return (_openBlock(), _createBlock(_component_AgendaEntry, {
                                            key: `d2-${location}-${timeKey}-${ae.objvalueid}`,
                                            ae: ae,
                                            agendatype: "accordion-timeline"
                                          }, null, 8, ["ae"]))
                                        }), 128))
                                      ])
                                    ], 10, _hoisted_24)
                                  ])
                                ], 12, _hoisted_20))
                          ], 64))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (time) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `d2-tr-${time}`,
                      class: "time-slot"
                    }, _toDisplayString(_ctx.formatTimeAmPm(time)), 1))
                  }), 128))
                ])
              ], 4)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_27, [
        (_ctx.showDay1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "font-weight-bold pb-3" }, "MONDAY, JULY 7, 2025", -1)),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredListDay1, (ae) => {
                  return (_openBlock(), _createBlock(_component_AgendaEntry, {
                    key: `list-d1-${ae.objvalueid}`,
                    ae: ae,
                    agendatype: "list",
                    class: "col-md-6"
                  }, null, 8, ["ae"]))
                }), 128)),
                (_ctx.filteredListDay1.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, "No events found for this day based on current filters."))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDay2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "font-weight-bold pb-3" }, "TUESDAY, JULY 8, 2025", -1)),
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredListDay2, (ae) => {
                  return (_openBlock(), _createBlock(_component_AgendaEntry, {
                    key: `list-d2-${ae.objvalueid}`,
                    ae: ae,
                    agendatype: "list",
                    class: "col-md-6"
                  }, null, 8, ["ae"]))
                }), 128)),
                (_ctx.filteredListDay2.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, "No events found for this day based on current filters."))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_34, [
        (_ctx.showDay1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "font-weight-bold pb-3" }, "MONDAY, JULY 7, 2025", -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredListDay1, (ae) => {
                  return (_openBlock(), _createBlock(_component_AgendaEntry, {
                    key: `list-m-d1-${ae.objvalueid}`,
                    ae: ae,
                    agendatype: "list"
                  }, null, 8, ["ae"]))
                }), 128)),
                (_ctx.filteredListDay1.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, "No events found for this day based on current filters."))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDay2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "font-weight-bold pb-3" }, "TUESDAY, JULY 8, 2025", -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredListDay2, (ae) => {
                  return (_openBlock(), _createBlock(_component_AgendaEntry, {
                    key: `list-m-d2-${ae.objvalueid}`,
                    ae: ae,
                    agendatype: "list"
                  }, null, 8, ["ae"]))
                }), 128)),
                (_ctx.filteredListDay2.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_38, "No events found for this day based on current filters."))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}